/**
 * Shared styles for single-file upload display rows
 * (FileUploadDisplay, FileUploadDownloadInput).
 * Keeps long filenames truncated with ellipsis while action icons stay fixed.
 */

export const fileDisplayContainerSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
  p: 1,
  border: "1px solid #ccc",
  borderRadius: 1,
  // Allow flex children to shrink so long filenames can ellipsize in grid layouts
  minWidth: 0,
  overflow: "hidden",
} as const;

export const fileNameTruncationSx = {
  flex: 1,
  minWidth: 0,
  fontSize: "14px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
} as const;

export const fileActionButtonsContainerSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 0.5,
  flexShrink: 0,
} as const;

export const fileActionButtonBaseSx = {
  minWidth: "auto",
  p: 0.5,
} as const;

export const fileUploadRootSx = {
  minWidth: 0,
  width: "100%",
} as const;
